import Hero from "../../shared/landing/hero/Hero"

import LogoGeopol from "../../../assets/img/logo-vikika-team+geopol.png"
import portraitImageUrl from "../../../assets/img/geopol-mobile.png"
import landscapeImageUrl from "../../../assets/img/geopol-desktop.png"

import "./index.css"
import { useNavigate } from "react-router-dom"
import PsychologySessionProducts from "../../shared/landing/products/PsychologySessionProducts"

const PsychologySession = () => {
  const navigate = useNavigate()

  const scrollToPromotions = () => {
    const promotionsElement = document.getElementById("PsychologySessionProductsContent")
    if (promotionsElement) {
      promotionsElement.scrollIntoView({ behavior: "smooth" })
    }
  }

  const handleClickBuyButton = () => {
    navigate(
      "/pago?product=eyJ2YWx1ZSI6eyJ2YWx1ZSI6Im9wdGlvbjEiLCJvcHRpb25fbmFtZSI6IlVuYSBzZXNpw7NuIiwibmV3X3ByaWNlX2xvbmVsbHkiOjcwLCJuZXdfcHJpY2VfcmVkdWNlZF9sb25lbGx5Ijo3MCwibmV3X3ByaWNlX2NvbXBvc2VkIjo5MCwibmV3X3ByaWNlX3JlZHVjZWRfY29tcG9zZWQiOjg1LCJoaWRlT25DaGVjayI6ZmFsc2UsImZlZUxvbmVseSI6MCwiZmVlQ29tcG9zZWQiOjAsImlkTG9uZWxseSI6IjI5OTY0NiIsImlkQ29tcG9zZWQiOiIyOTk2NTAifSwicHJvZHVjdElkIjoiMjk5NjQ1IiwidmFyaWFudElkIjoiMjk5NjQ2IiwicHJvZHVjdFByaWNlIjo3MCwibmFtZSI6IlBsYW4gUHNpY29sb2fDrWEiLCJpbWciOiJodHRwczovL3d3dy52aWtpa2EuZXMvd3AtY29udGVudC91cGxvYWRzLzIwMjEvMDYvUHNpY29sb2dpYS01LnBuZyIsImFsdCI6InBzaWNvbG9nw61hIiwicHJvZHVjdENhdGVnb3J5IjoicHN5Y2hvbG9neSIsImlzRW5QYXJlamEiOmZhbHNlLCJwcm9kdWN0U3Vic2NyaXB0aW9uIjpmYWxzZSwicHJvZHVjdFN1YnNjcmlwdGlvblByaWNlIjowfQ=="
    )
  }

  return (
    <div className="psychology-session-landing">
      <Hero
        isInternalLanding
        scrollToPromotions={scrollToPromotions}
        title="Plan <br/> psicología"
        subtitle="Tus emociones no son un obstáculo, son señales. Señales de que algo merece atención, comprensión y cuidado."
        ctaText="Descubre más"
      />
      <PsychologySessionProducts
        title="Rompe estigmas"
        subtitle="<strong>Nuestro servicio de psicología es online, flexible y adaptado a ti.</strong> Te acompañan psicólogas con experiencia, especializadas en autoestima, ansiedad, relaciones de pareja, gestión emocional y estrés. Cada proceso es único: te escuchamos, entendemos tu historia y trabajamos contigo desde un enfoque integral."
        price={70}
        linkTo="https://vikika.es/contacto"
        onClickBuyButton={handleClickBuyButton}
      />
    </div>
  )
}

export default PsychologySession
